'use strict';

var _regeneratorRuntime = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/asyncToGenerator");

Object.defineProperty(exports, '__esModule', {
  value: true
});

var isIpfs = require('is-ipfs');

var toCidAndPath = require('ipfs-core-utils/to-cid-and-path');

var drain = require('it-drain');

var utils = require('../../utils.js');

function _interopDefaultLegacy(e) {
  return e && typeof e === 'object' && 'default' in e ? e : {
    'default': e
  };
}

var isIpfs__default = /*#__PURE__*/_interopDefaultLegacy(isIpfs);

var drain__default = /*#__PURE__*/_interopDefaultLegacy(drain);

function resolvePath(_x, _x2, _x3) {
  return _resolvePath.apply(this, arguments);
}

function _resolvePath() {
  _resolvePath = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(_ref, name, options) {
    var ipns, repo, codecs, _toCidAndPath$toCidAn, cid, path;

    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            ipns = _ref.ipns, repo = _ref.repo, codecs = _ref.codecs;

            if (!isIpfs__default["default"].ipnsPath(name)) {
              _context.next = 3;
              break;
            }

            return _context.abrupt("return", ipns.resolve(name));

          case 3:
            _toCidAndPath$toCidAn = toCidAndPath.toCidAndPath(name), cid = _toCidAndPath$toCidAn.cid, path = _toCidAndPath$toCidAn.path;
            _context.next = 6;
            return drain__default["default"](utils.resolve(cid, path || '', codecs, repo, options));

          case 6:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return _resolvePath.apply(this, arguments);
}

exports.resolvePath = resolvePath;